import { api } from './client'
import { withCustomerIds } from './params'

export function fetchAgents(params = {}, customerIds = []) {
  return api.get('/agents', { params: withCustomerIds(params, customerIds) }).then((r) => r.data)
}

export function fetchAgent(id) {
  return api.get(`/agents/${id}`).then((r) => r.data)
}

export function fetchAgentHardware(id) {
  return api.get(`/agents/${id}/hardware`).then((r) => r.data)
}

export function fetchAgentSoftware(id) {
  return api.get(`/agents/${id}/software`).then((r) => r.data)
}

export function fetchAgentInstalledSoftware(id) {
  return api.get(`/agents/${id}/installed-software`).then((r) => r.data)
}

export function fetchAgentPatches(id) {
  return api.get(`/agents/${id}/patches`).then((r) => r.data)
}

export function fetchAgentContacts(id) {
  return api.get(`/agents/${id}/contacts`).then((r) => r.data)
}

export function fetchAgentAlerts(id, activeOnly = false) {
  return api
    .get(`/agents/${id}/alerts`, { params: { active_only: activeOnly } })
    .then((r) => r.data)
}

export function fetchAgentRmmData(id) {
  return api.get(`/agents/${id}/rmm-data`).then((r) => r.data)
}

export function fetchAgentAiAnalyses(id) {
  return api.get(`/agents/${id}/ai-analyses`).then((r) => r.data)
}

export function fetchAgentAiAnalysis(id, analysisId) {
  return api.get(`/agents/${id}/ai-analyses/${analysisId}`).then((r) => r.data)
}

export function fetchAgentToolkitSummary(id) {
  return api.get(`/agents/${id}/toolkit-summary`).then((r) => r.data)
}

export function updateAgentPostureExclusions(id, body) {
  return api.put(`/agents/${id}/posture-exclusions`, body).then((r) => r.data)
}
